/*
 * File: d:\projects\AutoFiFront\src\Content\SliderTool\SliderTool.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday April 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday April 6th 2023 10:07:30 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Slider from '@mui/joy/Slider';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from 'Content/SliderTool/SliderTool.module.css';
import { extendTheme } from '@mui/joy/styles';

type SliderToolProps = {
    setter: Function,
    value: number,
    minValue: number,
    maxValue: number,
    unit: string,
    unit2?: string,
    step?: number,
    title: string,
    calcFunction: Function,
    bgColor: string
};

function SliderTool(props: SliderToolProps) {

    return (
      <div className={`${styles.contribution}`}>
        <div className={`${styles.sliderTool}`}>
          {translator.decode(`pricing.${props.title}`).toUpperCase()}
          <Slider color={props.bgColor.toLowerCase() == "suv" ? "suv" : props.bgColor.toLowerCase() == "break" ? "break" : props.bgColor.toLowerCase() == "sedan" ? "sedan" : props.bgColor.toLowerCase() == "citycar" ? "citycar" : props.bgColor.toLowerCase() == "utility" ? "utility" : "neutre"} onChangeCommitted={(e:any) => {props.calcFunction()}} onChange={(e:any)=>props.setter(e.target.value)} step={props.step} disabled={false} min={props.minValue} max={props.maxValue} defaultValue={props.value} orientation="horizontal" size="lg" valueLabelDisplay="auto" />
          <div className={`${styles.marksHolder}`}>
            <div className={`${styles.marksLeft}`}>
                {props.minValue} {props.unit}
            </div>
            <div className={`${styles.marksRight}`}>
                {props.maxValue} {props.unit}
            </div>
          </div>
        </div>
        <div style={{width:"20%"}}>
            {props.value} { props.unit2 ? props.unit2 : props.unit }
        </div>
      </div>
    );
}

export default SliderTool;
